import { Stack, Tooltip, Typography, useTheme } from '@mui/material';
import CachedIcon from '@mui/icons-material/Cached';
import StarIcon from '@mui/icons-material/Star';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';

export interface BadgeProps {
  dataTestId: string;
  showText?: boolean;
  showTooltip?: boolean;
}

export const CredentialVerifiedBadge: React.FC<BadgeProps> = ({
  dataTestId,
  showTooltip,
  showText,
}) => {
  const theme = useTheme();

  if (showTooltip) {
    return (
      <Tooltip title="Credential verified">
        <span data-testid={dataTestId}>
          <VerifiedUserOutlinedIcon sx={{ color: theme.palette.primary.main }} />
        </span>
      </Tooltip>
    );
  }

  return (
    <Stack data-testid={dataTestId} direction="row" sx={{ mt: 0.5 }}>
      <VerifiedUserOutlinedIcon sx={{ color: theme.palette.primary.main }} />
      &nbsp;
      {showText && <Typography>Credential verified</Typography>}
    </Stack>
  );
};

export const HighlyRelevantSkillsBadge: React.FC<BadgeProps> = ({
  dataTestId,
  showTooltip,
  showText,
}) => {
  const theme = useTheme();

  if (showTooltip) {
    return (
      <Tooltip title="Highly relevant skills">
        <span data-testid={dataTestId}>
          <StarIcon sx={{ color: theme.palette.yellow.main }} />
        </span>
      </Tooltip>
    );
  }

  return (
    <Stack data-testid={dataTestId} direction="row" sx={{ mt: 0.5 }}>
      <StarIcon sx={{ color: theme.palette.yellow.main }} /> &nbsp;
      {showText && <Typography variant="body2">Highly relevant skills</Typography>}
    </Stack>
  );
};

export const HighRetentionPossibleBadge: React.FC<BadgeProps> = ({
  dataTestId,
  showTooltip,
  showText,
}) => {
  const theme = useTheme();

  if (showTooltip) {
    return (
      <Tooltip title="High retention possible">
        <span data-testid={dataTestId}>
          <CachedIcon sx={{ color: theme.palette.purple.main }} />
        </span>
      </Tooltip>
    );
  }

  return (
    <Stack data-testid={dataTestId} direction="row" sx={{ mt: 0.5 }}>
      <CachedIcon sx={{ color: theme.palette.purple.main }} />
      &nbsp;
      {showText && <Typography variant="body2">High retention possible</Typography>}
    </Stack>
  );
};
